export default __webpack_public_path__ + "static/media/logo-white.0853af16.png";